import { HTMLAttributes, ReactNode } from 'react';
import { card } from './index.css';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Card = ({ children, className, ...rest }: Props) => (
  <div className={[card, className].filter(Boolean).join(' ')} {...rest}>
    {children}
  </div>
);

export default Card;
